import {library, dom} from "@fortawesome/fontawesome-svg-core";
import {faBars} from "@fortawesome/pro-regular-svg-icons/faBars";
import {faSearch} from "@fortawesome/pro-light-svg-icons/faSearch";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {faPhoneVolume} from "@fortawesome/pro-solid-svg-icons/faPhoneVolume";
import {faHeart} from "@fortawesome/pro-solid-svg-icons/faHeart";
import {faStar} from "@fortawesome/pro-solid-svg-icons/faStar";
import {faComments} from "@fortawesome/pro-solid-svg-icons/faComments";
import {faTimes} from "@fortawesome/pro-regular-svg-icons/faTimes";

export function loadFontAwesomeIcons() {
	// @ts-ignore
	library.add(faBars, faSearch, faUser, faPhoneVolume, faHeart, faStar, faComments, faTimes);
	dom.watch();
}
